import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const items = ['Zenify Neck Stretcher Device', 'Premium Inflation Pump', 'Adjustable Support System', 'Ready to use out of the box'];
export function OfferStack() {
  return <section className="bg-brand-black text-white py-16 lg:py-24 px-4 sm:px-6 lg:px-8" data-id="element-91">
      <div className="max-w-3xl mx-auto" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white/5 border border-white/10 rounded-3xl p-8 sm:p-12 backdrop-blur-sm" data-id="element-93">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-8" data-id="element-94">
            Everything You Get:
          </h2>

          <div className="space-y-4 mb-10 max-w-md mx-auto" data-id="element-95">
            {items.map((item, index) => <div key={index} className="flex items-center gap-4 bg-white/5 p-4 rounded-xl" data-id="element-96">
                <div className="bg-brand-purple p-1 rounded-full" data-id="element-97">
                  <Check className="w-5 h-5 text-white" data-id="element-98" />
                </div>
                <span className="text-lg font-medium" data-id="element-99">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-100">
            <div className="flex justify-center items-center gap-4 mb-6" data-id="element-101">
              <span className="text-xl text-[#aaa] line-through" data-id="element-102">$59.99</span>
              <span className="text-[28px] sm:text-4xl font-bold text-brand-purple-light" data-id="element-103">
                $24.99
              </span>
            </div>

            <p className="text-yellow-400 text-sm font-semibold mb-3 flex items-center gap-1.5 justify-center" data-id="element-104">
              <span data-id="element-105">⚠️</span> Limited stock available – selling fast
            </p>
            <a href="https://zenifyliving.com/cart/48194365325482:1?checkout" className="block w-full sm:w-auto text-center bg-brand-purple hover:bg-brand-purple-dark text-white font-bold text-lg py-4 px-10 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(124,58,237,0.4)] hover:shadow-[0_0_30px_rgba(124,58,237,0.6)] hover:scale-105" data-id="element-106">
              Get Instant Relief Now →
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}